module.exports = __webpack_public_path__ + "static/laptop_ramver-c2c96d85b4495993beb63bb6eacce850.png";